import * as Log from "web-ui/log"

// web-ui.js and elements.js each bundle their own copy of this module, as can
// other projects' bundles. A symbol from the global registry gives every copy
// the same key, so a hold placed through one copy is seen by all of them.
// - Shaun, Fri Oct 9 2026
const holdsKey = Symbol.for("web-ui.morphdom.holds")

export function morphdomHold(element) {
  let elementHolds = element[holdsKey]

  if (!elementHolds) {
    elementHolds = new Set()
    element[holdsKey] = elementHolds
  }

  const hold = {
    release() {
      if (!elementHolds.delete(hold)) {
        return
      }

      if (elementHolds.size === 0) {
        delete element[holdsKey]
      }

      debug("Released", { id: element.id, holds: elementHolds.size })
    }
  }

  elementHolds.add(hold)

  debug("Placed", { id: element.id, holds: elementHolds.size })

  return hold
}

export function isMorphdomHeld(element) {
  return holdsKey in element
}

function debug(message, data) {
  Log.debug("Morphdom Hold - " + message, data)
}
